import React from 'react';
import { useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { toApiRequest } from '~/components/common/Notes/Modal/config';
import { useCoachContext } from '~/components/pages/profile';
import { model as clientNoteModel, clientNotesQueryKey } from '~/model/Client/Notes';
import { model as personalNoteModel, Note, NoteType } from '~/model/Notes';
import { notesQueryKey } from '~/model/Notes/hooks';
import { Modal as Component, Props as ComponentProps } from '../Modal';

interface Props extends Omit<ComponentProps, 'onSubmit' | 'initialValues'> {
  note: Note;
}

export const EditModal = ({ note, ...otherProps }: Props) => {
  const queryClient = useQueryClient();
  const { coach } = useCoachContext();

  const clientId = note.type === NoteType.COACH ? undefined : note.clientId;

  const { name, description } = note;

  return (
    <Component
      onSubmit={async (values) => {
        const data = toApiRequest(values);
        await personalNoteModel(coach.id).edit(note.id, data);
        if (values.client) {
          await clientNoteModel(values.client).edit(note.id, data);
          await queryClient.invalidateQueries(clientNotesQueryKey(values.client));
        }
        await queryClient.invalidateQueries(notesQueryKey);
        await queryClient.removeQueries([notesQueryKey], { inactive: true });
        toast.success('Your note has been updated!');
      }}
      testId="edit-note-modal"
      initialValues={{ name, description, client: clientId }}
      {...otherProps}
    />
  );
};
